__turbopack_context__.v({
  "affiliated_logo_content": "HeroSubBannerJob-module-scss-module__Ae_7Aa__affiliated_logo_content",
  "asia_pacific": "HeroSubBannerJob-module-scss-module__Ae_7Aa__asia_pacific",
  "brochure_container": "HeroSubBannerJob-module-scss-module__Ae_7Aa__brochure_container",
  "brochure_share_btn_container": "HeroSubBannerJob-module-scss-module__Ae_7Aa__brochure_share_btn_container",
  "content_container": "HeroSubBannerJob-module-scss-module__Ae_7Aa__content_container",
  "content_wrapper": "HeroSubBannerJob-module-scss-module__Ae_7Aa__content_wrapper",
  "course_name": "HeroSubBannerJob-module-scss-module__Ae_7Aa__course_name",
  "download_br": "HeroSubBannerJob-module-scss-module__Ae_7Aa__download_br",
  "duration": "HeroSubBannerJob-module-scss-module__Ae_7Aa__duration",
  "global_accred": "HeroSubBannerJob-module-scss-module__Ae_7Aa__global_accred",
  "global_text": "HeroSubBannerJob-module-scss-module__Ae_7Aa__global_text",
  "heading": "HeroSubBannerJob-module-scss-module__Ae_7Aa__heading",
  "img_container": "HeroSubBannerJob-module-scss-module__Ae_7Aa__img_container",
  "program_Form": "HeroSubBannerJob-module-scss-module__Ae_7Aa__program_Form",
  "root": "HeroSubBannerJob-module-scss-module__Ae_7Aa__root",
  "share_icon": "HeroSubBannerJob-module-scss-module__Ae_7Aa__share_icon",
  "subheading": "HeroSubBannerJob-module-scss-module__Ae_7Aa__subheading",
  "tooltip": "HeroSubBannerJob-module-scss-module__Ae_7Aa__tooltip",
  "ugc_ent": "HeroSubBannerJob-module-scss-module__Ae_7Aa__ugc_ent",
});
